const vendorPaths: string[] = [
  "dashboard/customer/vendor",
  "quotes/vendor",
  "quoteLine/vendor",
  "company/vendor/customer",
  "register/newUser",
  "documents/customer/vendor",
  "buildings/customer/vendor",
  "priceList/vendor",
  "services/customer/vendor",
  "user/airx/customer/vendor"
];
export default vendorPaths;
